import React from 'react';
import { boardPrinciples } from '../data/governance';
export function BoardPhilosophy() {
  return <div data-id="element-83" data-mp="y1344w9o8ngz">
      <figure className="border-l-4 border-wheat py-2 pl-6 md:pl-10" data-id="element-84" data-mp="xzs2b1zsdpsi">
        <blockquote className="max-w-3xl font-serif text-2xl italic leading-snug text-forest md:text-[2rem] md:leading-[1.3]" data-id="element-85" data-mp="jc6wh0bj1cgw">
          “A good board challenges constructively, judges independently and, once it has decided, acts as one. My role
          as chair is to make that possible.”
        </blockquote>
        <figcaption className="mt-5 text-sm text-charcoal-muted" data-id="element-86" data-mp="falre158i2h9">— Jim Godfrey</figcaption>
      </figure>

      <dl className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2 xl:grid-cols-4" data-id="element-87" data-mp="dulra4yvuj7">
        {boardPrinciples.map(p => <div key={p.title} className="border-t border-forest pt-4" data-id="element-88" data-mp="5co3jerae7p6">
            <dt className="font-serif text-lg text-forest" data-id="element-89" data-mp="1uqu9jqji3v1k">{p.title}</dt>
            <dd className="mt-2 text-sm leading-relaxed text-charcoal" data-id="element-90" data-mp="1zq6to3izmo0g">{p.text}</dd>
          </div>)}
      </dl>
    </div>;
}